// TEMPORARY admin account switcher (owner request, admin-only, to be removed).
//
// Lets an admin hop between two specific accounts to test the premium vs free
// experience without logging out. It is impersonation, so it is built the
// careful way: only an admin can START a switch (the endpoint is admin-gated),
// and returning is authorised by a SERVER-SIGNED ticket the client holds —
// tamper-proof, short-lived, and only ever usable to return to a real admin.
//
// Native uses bearer tokens, not cookies, so the return ticket is a signed
// value the client stores rather than a Set-Cookie.

/** The only accounts this tool will switch between (owner's two accounts). */
export const ADMIN_SWITCH_EMAILS = [
  "mohsen.norzahi@gmail.com", // greezy (admin)
  "luca.a666a@gmail.com",     // luca.a666a (member)
] as const;

/** How long a return ticket stays valid — a leaked ticket must not live on. */
export const RETURN_TICKET_TTL_SEC = 12 * 3600;

export interface ReturnTicket {
  /** The admin to return to. */
  adminId: number;
  exp: number; // unix seconds
}
